<template>
  <div>
        <div class="full-length-block">
            <div class="content-code">
                <div class="bottomRight-request">
                <p>{{$t('ExampleRequest')}}</p>
                <p>{{$t('ws')}}</p>
                </div>
                <div class="preload-bg">
                <div class="preloadURL">
                <p>{{$t('curlGET')}} <span ref="url_link_add">'ws://server-address:port/ws?token=YoC1Buiy'</span></p>
                </div>
                <a href="#" @click.prevent="$parent.handleCopy($refs.url_link_add)" class="copyURL"><feather type="copy"></feather> </a>
                </div>
            </div>
            <div class="content">
                <div class="overflow-hidden content-section" id="content-get-started">
                    <div class="api-information">
                        <div class="folder-name"><p class="headTitle">{{$t('streaming')}}</p></div>
                        <div class="folder-description"></div>
                    </div>
                    <div class="api-information">
                        <div class="heading">
                        <div class="name addIcon">
                            <span class="GET method green" title="GET">{{$t('GET')}}</span>
                            {{$t('ws')}} <feather type="lock"></feather>
                            <span class="lock-icon"></span>
                        </div>
                        </div>
                        <div class="url">ws://server-address:port/ws?token=YoC1Buiy</div>
                        <div class="description request-description">
                            <p>{{$t('subscribeMarketsCommand')}}</p>
                        </div>
                        <div class="url">{"m": "subscribe", "p": ["BTC-USD", "GBPUSD", "USDJPY"]}</div>
                        <div class="description request-description">
                            <p>{{$t('unsubscribeMarketsCommand')}}</p>
                        </div>
                        <div class="url">{"m": "unsubscribe", "p": ["BTC-USD", "GBPUSD", "USDJPY"]}</div>
                        <div class="description request-description">
                            <p>{{$t('tickerMessage')}}</p>
                            <div class="desc_code">
                                <pre class="click-to-expand-wrapper is-snippet-wrapper  language-undefined" :class="(read_more)?'is-expandable':''">
                                    <code class=" is-highlighted language-undefined">{
    "event": "ticker",
    "payload": [{
        "m": "BTC-USD",
        "time": "2020-05-06T12:03:24.03071147Z",
        "bid": 9375.196,
        "ask": 9379.384
    }]
}
                                    </code>
                                </pre>
                                <div class="expandMore">
                                    <a class="showMore-btn" v-if="!read_more" href="#" @click.prevent="read_more = true">{{$t('ReadMore')}}</a>  
                                    <a class="showLess-btn" v-if="read_more" href="#" @click.prevent="read_more = false">{{$t('ReadLess')}}</a>  
                                </div>
                            </div>
                        </div>
                        <div class="description request-description">
                            <p>{{$t('orderbook')}}</p>
                            <div class="desc_code">
                                <pre class="click-to-expand-wrapper is-snippet-wrapper  language-undefined" :class="(read_more1)?'is-expandable':''">
                                    <code class=" is-highlighted language-undefined">{
    "event": "orderbook",
    "payload": [{
        "m": "BTC-USD",
        "buy": [{
            "Quantity": "0.17",
            "Rate": "9351.939"
        }, {
            "Quantity": "1.4304",
            "Rate": "9356.304"
        }, {
            "Quantity": "0.1",
            "Rate": "9356.565"
        }, {
            "Quantity": "0.0762237",
            "Rate": "9356.597"
        }, {
            "Quantity": "0.35",
            "Rate": "9356.598"
        }],
        "sell": [{
            "Quantity": "0.2",
            "Rate": "9364.922"
        }, {
            "Quantity": "0.10678387",
            "Rate": "9361.752"
        }, {
            "Quantity": "0.16000097",
            "Rate": "9361.293"
        }, {
            "Quantity": "0.05",
            "Rate": "9360"
        }, {
            "Quantity": "0.09",
            "Rate": "9359.999"
        }]
    }]
}
                                    </code>
                                </pre>
                                <div class="expandMore">
                                    <a class="showMore-btn" v-if="!read_more1" href="#" @click.prevent="read_more1 = true">{{$t('ReadMore')}}</a>  
                                    <a class="showLess-btn" v-if="read_more1" href="#" @click.prevent="read_more1 = false">{{$t('ReadLess')}}</a>  
                                </div>
                            </div>
                        </div>
                        <div class="description request-description">
                            <p>{{$t('OrderMsgExp')}}</p>
                            <div class="desc_code">
                                <pre class="click-to-expand-wrapper is-snippet-wrapper  language-undefined" :class="(read_more2)?'is-expandable':''">
                                    <code class=" is-highlighted language-undefined">{
    "event":"order",
    "payload":{
        "AccountID":224,
        "Action":"I",
        "OpenTime":"2019-10-16T07:10:10.933277000",
        "OrderID":72785839,
        "Pending":"N",
        "Price":1.10277,
        "Quantity":100,
        "Side":0,
        "Symbol":"EURUSD",
        "TradeID":null,
        "Type":"I"
    }
}
                                    </code>
                                </pre>
                                <div class="expandMore">
                                    <a class="showMore-btn" v-if="!read_more2" href="#" @click.prevent="read_more2 = true">{{$t('ReadMore')}}</a>  
                                    <a class="showLess-btn" v-if="read_more2" href="#" @click.prevent="read_more2 = false">{{$t('ReadLess')}}</a>  
                                </div>
                            </div>
                        </div>
                        <div class="description request-description">
                            <p>{{$t('accountMsgformat')}}</p>
                            <div class="desc_code">
                                <pre class="click-to-expand-wrapper is-snippet-wrapper  language-undefined" :class="(read_more3)?'is-expandable':''">
                                    <code class=" is-highlighted language-undefined">________________________________________________________
|parameter |type  |required|description                 |
|----------|------|--------|----------------------------|
|event     |string|    +   |event name                  |
|payload   |object|    +   |object structure            |
|AccountID |int   |    +   |account identifier          |
|Action    |char  |    +   |I-insert, U-update, D-delete|
|Balance   |double|    -   |account balance value       |
|Income    |double|    -   |balance change value        |
|Type      |string|    -   |balance transaction type    |
|UsedMargin|double|    -   |account used margin         |
________________________________________________________
                                    </code>
                                </pre>
                                <div class="expandMore">
                                    <a class="showMore-btn" v-if="!read_more3" href="#" @click.prevent="read_more3 = true">{{$t('ReadMore')}}</a>  
                                    <a class="showLess-btn" v-if="read_more3" href="#" @click.prevent="read_more3 = false">{{$t('ReadLess')}}</a>  
                                </div>
                            </div>
                        </div>
                        <div class="description request-description">
                            <p>{{$t('tradeMsgformat')}}</p>
                            <div class="desc_code">
                                <pre class="click-to-expand-wrapper is-snippet-wrapper  language-undefined" :class="(read_more4)?'is-expandable':''">
                                    <code class=" is-highlighted language-undefined">{   
    "event":"trade",
    "payload":{
        "AccountID":224,
        "Action":"I",
        "OpenOrderID":72785845,
        "OpenTime":"2019-10-16T09:09:52.033833000",
        "Price":1.10425,
        "Quantity":100,
        "Side":0,
        "Symbol":"EURUSD",
        "TradeID":72785846
    }
}
                                    </code>
                                </pre>
                                <div class="expandMore">
                                    <a class="showMore-btn" v-if="!read_more4" href="#" @click.prevent="read_more4 = true">{{$t('ReadMore')}}</a>  
                                    <a class="showLess-btn" v-if="read_more4" href="#" @click.prevent="read_more4 = false">{{$t('ReadLess')}}</a>  
                                </div>
                            </div>
                        </div>
                        <div class="description request-description">
                            <p>{{$t('OrderMsgExp')}}</p>
                            <div class="desc_code">
                                <pre class="click-to-expand-wrapper is-snippet-wrapper  language-undefined":class="(read_more5)?'is-expandable':''">
                                    <code class=" is-highlighted language-undefined">___________________________________________________________
|parameter   |type  |required|description                 |
|------------|------|--------|----------------------------|
|event       |string|    +   |event name                  |
|payload     |object|    +   |object structure            |
|AccountID   |int   |    -   |account identifier          |
|Action      |char  |    +   |I-insert, U-update, D-delete|
|CloseOrderID|int   |    -   |closing order identifier    |
|CloseTime   |date  |    -   |closing date                |
|OpenOrderID |int   |    -   |opening order identifier    |
|OpenTime    |date  |    -   |opening date                |
|Price       |double|    +   |opening/closing price       |
|ProfitLoss  |double|    -   |closed trade profit loss    |
|Quantity    |double|    +   |opening/closing amount      |
|Side        |int   |    -   |trade side (0-sell, 1-buy)  |
|Symbol      |string|    -   |instrument symbol name      |
|TradeID     |int   |    +   |trade identifier            |
___________________________________________________________
                                    </code>
                                </pre>
                                <div class="expandMore">
                                    <a class="showMore-btn" v-if="!read_more5" href="#" @click.prevent="read_more5 = true">{{$t('ReadMore')}}</a>  
                                    <a class="showLess-btn" v-if="read_more5" href="#" @click.prevent="read_more5 = false">{{$t('ReadLess')}}</a>  
                                </div>
                            </div>
                        </div>
                        <div class="query-params">
                        <div class="heading">{{$t('PARAMS')}}</div>
                            <hr>
                            <div class="param row justify-content-end">
                            <div class="name col-md-3 col-xs-12">{{$t('token')}}</div>
                            <div class="value col-md-9 col-xs-12">YoC1Buiy</div>
                                <div class="description col-md-9 col-xs-12">
                                </div>
                            </div>
                        </div>  
                    </div> 
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'streaming',
    data(){
        return {
            read_more: false,
            read_more1: false,
            read_more2: false,
            read_more3: false,
            read_more4: false,
            read_more5: false,
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/fxView/tradingtools/api_document/streaming.vue